import MedicaidHistory from './MedicaidHistory';

export default MedicaidHistory;
